import { createElement, memo, useEffect, useState, Fragment, useMemo } from "react";
import methodModel from "../../../methods/methods";
import SelectDropdown from "../SelectDropdown";
import "./style.scss";
import ReactQuill from "react-quill";
import PhoneInput from "react-phone-input-2";
import "react-quill/dist/quill.snow.css";
import { IoClose } from "react-icons/io5";
import MultiSelectDropdown from "../MultiSelectDropdown";
import { PiArrowFatLineRightDuotone } from "react-icons/pi";
import Swal from "sweetalert2";
import datepipeModel from "../../../models/datepipemodel";
import CKEditorComponent from "./BlogEditor";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import OptionDropdown from "../../OptionDropdown";


const FormControl = memo(function FormControl({
  isLoading = false,
  name,
  id = "",
  valueType = "string",
  onFocus,
  onInputChange = (e: any) => { },
  filterOption,
  inputValue = "",
  displayValue = "name",
  placeholder = "",
  type = "text",
  options = [],
  error,
  label,
  setOptions = () => { },
  required = false,
  onChange = () => { },
  maxlength = "",
  minlength = "",
  min = "",
  max = "",
  className = "",
  onBlur = () => { },
  value,
  disabled = false,
  theme = "",
  onkeyDown = (e: any) => { },
  isClearable = true,
  countryCodeEditable = false,
  editorType = "quill",
  selectedValue,
  buttonClass = "",
  dropdownClass = "",
  getDisplayLabel = (val: any) => val,
  isCreate = false,
  searchText = "Search",
  searchType = "text",
  position = "absolute",
  modules,
  formats

}: any) {
  const [activeTab, setActiveTab] = useState<"editor" | "html">("editor");
  const selectedLabel = getDisplayLabel(selectedValue);

  const [text, setText] = useState("");

  const defaultModules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }]
    ]
  };

  const defaultFormats = [
    "bold",
    "italic",
    "underline",
    "list"
  ];

  const add = () => {
    let arr = value || [];
    if (text) {
      arr.push(text);
    }
    onChange(arr);
    setText("");
  };

  const remove = (i: any) => {
    let arr = value || [];
    arr = arr.filter((itm: any, index: any) => index != i);
    onChange(arr);
  };

  const addItem = (v: any) => {
    let arr = value || [];
    let ext = arr?.find((itm: any) => itm == v);

    if (ext) {
      arr = arr.filter((itm: any) => itm != v);
    } else {
      arr.push(v);
    }

    onChange(arr);
  };

  const [grams, setGrams] = useState(value || 0); // Store grams value
  const [milligrams, setMilligrams] = useState(value ? value * 1000 : 0); // Store milligrams value

  useEffect(() => {
    if (type == "gram|mili") {
      setGrams(Number(value || 0));
      setMilligrams(Number(value || 0) * 1000);
    }

    if (type == "dob") {
      let v: any = {};
      if (value) {
        v = datepipeModel.datetostring(value);
        v = v.split("-");
        v = {
          year: Number(v[0]),
          month: Number(v[1]),
          date: Number(v[2]),
        };
      }
      setDob({
        ...dob,
        ...v,
      });
    }
  }, [value]);

  const [dob, setDob] = useState<any>({
    year: "",
    month: "",
    date: "",
  });

  const days = [];
  const months = [];
  const year = new Date().getFullYear();
  const years = [];

  for (let i = 1; i <= 12; i++) {
    months.push({ name: i, id: i });
  }

  for (let i = 1; i <= 31; i++) {
    days.push({ name: i, id: i });
  }

  for (let i = 21; i <= 100; i++) {
    years.push({ name: year - i, id: year - i });
  }

  const handleYearChange = (e: any) => {
    const selectedYear = Number(e.target.value);
    const currentYear = new Date().getFullYear();
    const age = currentYear - selectedYear;

    let year: any = Number(selectedYear);

    if (age < 21) {
      year = "";
      Swal.fire({
        imageUrl: "/assets/img/age.png",
        imageHeight: 150,
        title: "Age Restricted!",
        text: "Your age is less than 21. You are not eligible for this service.",
        // titleText:'Your age is less than 21. You are not eligible for this service.',
        imageAlt: "A tall image",
        confirmButtonText: "Got it, thanks!",
      });
    } else {
      dobChange({ year: year });
    }
  };

  const dobRequired =
    required || dob.year || dob.month || dob.date ? true : false;

  const dobChange = (p: any) => {
    let dobValue = { ...dob, ...p };
    let value: any = "";
    if (dobValue.date && dobValue.month && dobValue.year) {
      value = new Date(
        Number(dobValue.year),
        Number(dobValue.month) - 1,
        Number(dobValue.date)
      );
      value = datepipeModel.datetostring(value);
    }
    onChange(value);
    setDob((prev: any) => ({
      ...prev,
      ...dobValue,
    }));
  };

  const dobSelected = useMemo(() => {
    let value = false;
    if (dob.year || dob.month || dob.date) value = true;
    return value;
  }, [dob]);

  return (
    <>
      <div className={`formWrapper relative w-auto`}>
        {label ? (
          <>
            <label className="text-sm mb-2 block">
              {label}{" "}
              {required ? (
                <>
                  <span className="star">*</span>
                </>
              ) : (
                <></>
              )}
            </label>
          </>
        ) : (
          <></>
        )}

        {type == "select" ? (
          <>
            {theme == "option" ? (
              <>
                <OptionDropdown
                  position={position}
                  maxlength={maxlength}
                  minlength={minlength}
                  type={searchType}
                  isLoading={isLoading}
                  searchText={searchText}
                  isCreate={isCreate}
                  options={options}
                  disabled={disabled}
                  valueType={valueType}
                  displayValue={displayValue}
                  onChange={onChange}
                  placeholder={placeholder}
                  value={value || ""}
                  showUnselect={isClearable}
                />
              </>
            ) : (
              <>
                <SelectDropdown
                  id={`statusDropdown_${id}`}
                  displayValue={displayValue}
                  className={className}
                  valueType={valueType}
                  setOptions={setOptions}
                  filterOption={filterOption}
                  onInputChange={onInputChange}
                  inputValue={inputValue}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  placeholder={placeholder}
                  intialValue={value || ""}
                  name={name}
                  theme={theme}
                  result={(e: any, full: any) => {
                    onChange(e.value, full);
                  }}
                  maxlength={maxlength}
                  minlength={minlength}
                  isLoading={isLoading}
                  isClearable={isClearable}
                  required={required}
                  options={options}
                  disabled={disabled}
                />
              </>
            )}
          </>
        ) : type == "multiselect" ? (
          <MultiSelectDropdown
            id={`statusDropdown_${id}`}
            displayValue={displayValue}
            className={className}
            placeholder={placeholder}
            intialValue={value || ""}
            result={(e: any) => {
              onChange(e.value);
            }}
            options={options}
            disabled={disabled}
            isLoading={isLoading}
            required={required}
          />
        ) : type == "phone" ? (
          <>
            <PhoneInput
              country={"us"}
              value={value}
              inputProps={{
                required: required,
                id: id,
                // value:value
              }}

              enableSearch={true}
              onChange={(e) => {
                console.log(e);

                onChange(e)
              }}
              countryCodeEditable={countryCodeEditable}
              onBlur={onBlur}
            />
          </>
        ) : type == "gram|mili" ? (
          <div className="space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 rtl:space-x-reverse flex items-end flex-col sm:flex-row mb-4">
            <div>
              <div className="flex">
                <div className="relative w-full">
                  <input
                    type="text"
                    required={required}
                    value={grams}
                    disabled={disabled}
                    onChange={(e) => {
                      let value = methodModel.isNumber(e);
                      setGrams(value);
                      onChange(value);
                      setMilligrams(Number(value || 0) * 1000);
                    }}
                    className="border border-gray py-2 px-4 w-full"
                  />
                </div>
                <button
                  id="dropdown-crypto-button"
                  data-dropdown-toggle="dropdown-crypto"
                  className=" inline-flex items-center py-2 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-e-lg "
                  type="button"
                >
                  g
                </button>
              </div>
            </div>
            <button
              type="button"
              className="px-4  py-2.5 text-xl font-medium  focus:outline-none  rounded-lg bg-gray-200 text-gray-900 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-600 dark:bg-gray-700 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600"
            >
              <PiArrowFatLineRightDuotone />

              <span className="sr-only">Convert currency</span>
            </button>
            <div>
              <div className="flex">
                <div className="relative w-full">
                  <input
                    type="text"
                    required={required}
                    value={milligrams}
                    disabled={disabled}
                    onChange={(e) => {
                      let value = methodModel.isNumber(e);
                      setMilligrams(value);
                      onChange(Number(value || 0) / 1000);
                      setGrams(Number(value || 0) / 1000);
                    }}
                    className="border border-gray py-2 px-4 w-full"
                  />
                </div>
                <button
                  id="dropdown-crypto-button"
                  data-dropdown-toggle="dropdown-crypto"
                  className=" inline-flex items-center py-2 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-e-lg "
                  type="button"
                >
                  mg
                </button>
              </div>
            </div>
          </div>
        ) : type == "number" ? (
          <input
            type="text"
            name={name}
            id={id}
            className={`relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 text-sm text-[#000] border border-gray-200 border border-gray-200 ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={maxlength}
            minLength={minlength}
            min={min}
            max={max}
            disabled={disabled}
            onChange={(e) => onChange(methodModel.isNumber(e))}
          />
        ) : type == "textarea" ? (
          <>
            <textarea
              name={name}
              id={id}
              className={`relative bg-white w-full ${className} rounded-lg h-[150px] border flex items-center gap-2 z-9 overflow-hidden px-2`}
              required={required}
              placeholder={placeholder}
              value={value || ""}
              maxLength={maxlength}
              minLength={minlength}
              disabled={disabled}
              onChange={(e) => onChange(e.target.value)}
            />
          </>
        ) : type == "badge" ? (
          <>
            <div className="flex">
              <input
                type="text"
                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 text-sm  border border-gray-200"
                placeholder={placeholder}
                value={text}
                disabled={disabled}
                onChange={(e) => setText(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-primary ml-2"
                disabled={disabled}
                onClick={add}
              >
                Add
              </button>
            </div>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              {value?.map((itm: any, i: any) => {
                return (
                  <span className="bg-primary rounded-md text-white text-xs p-2 flex items-center gap-2 break-all ">
                    {itm}
                    <IoClose className="cursor-pointer " onClick={() => remove(i)} />
                  </span>
                );
              })}
            </div>
          </>
        ) : type == "dob" ? (
          <>
            <div className="flex items-center  overflow-hidden mt-3 mb-3">
              <div
                className={` input_dates flex items-center  gap-1 w-full  ${className}`}
              >
                <select
                  value={dob.month}
                  required={dobRequired}
                  onChange={(e) => {
                    dobChange({ month: e.target.value });
                  }}
                  className={`text-sm px-3 h-10 w-full md:w-32 text-md bg-white border focus:outline-0  border-gray-300 rounded-full font-normal ${dobSelected && !dob.month ? "border border-red-500" : ""
                    }`}
                >
                  <option value="">Month</option>
                  {months.map((itm) => {
                    return <option value={itm.id}>{itm.name}</option>;
                  })}
                </select>
                <select
                  value={dob.date}
                  required={dobRequired}
                  onChange={(e) => {
                    dobChange({ date: e.target.value });
                  }}
                  className={`text-sm px-3 h-10 w-full md:w-32 text-md bg-white border focus:outline-0  border-gray-300 rounded-full font-normal ${dobSelected && !dob.date ? "border border-red-500" : ""
                    }`}
                >
                  <option value="">Day</option>
                  {days.map((itm: any) => {
                    return <option value={itm.id}>{itm.name}</option>;
                  })}
                </select>
                <select
                  value={dob.year}
                  required={dobRequired}
                  onChange={(e) => {
                    handleYearChange(e);
                  }}
                  className={`text-sm px-3 h-10 w-full md:w-32 text-md bg-white border focus:outline-0  border-gray-300 rounded-full font-normal ${dobSelected && !dob.year ? "border border-red-500" : ""
                    }`}
                >
                  <option value="">Year</option>
                  {years.map((itm) => {
                    return (
                      <option key={itm.id} value={itm.id}>
                        {itm.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </>
        ) : type == "radio" ? (
          <>
            <div
              className={`${className ? className : "flex items-center gap-x-4 flex-wrap "
                }`}
            >
              {options.map((itm: any) => {
                return (
                  <div className="">
                    {" "}
                    <label
                      className={`border border-gray-300 px-6 py-2 mb-2 rounded-lg flex cursor-pointer ${itm.className || ""
                        }`}
                    >
                      <input
                        type="radio"
                        checked={value == itm.id ? true : false}
                        onChange={(e) => onChange(itm.id)}
                        className="mr-2"
                        name={name}
                        disabled={disabled}
                      />
                      {itm.name}
                    </label>
                  </div>
                );
              })}
            </div>
          </>
        ) : type == "editor" ? (
          <>
            <div className="flex border-b mb-2">
              <button
                onClick={() => setActiveTab("editor")}
                type="button"
                className={`px-4 py-2 font-medium ${activeTab === "editor"
                  ? "border-b-2 border-[#570910] text-[#570910] font-semibold"
                  : "text-gray-600"
                  }`}
              >
                Editor
              </button>
              <button
                onClick={() => setActiveTab("html")}
                type="button"
                className={`px-4 py-2 font-medium ${activeTab === "html"
                  ? "border-b-2 border-[#570910] text-[#570910] font-semibold"
                  : "text-gray-600"
                  }`}
              >
                HTML
              </button>
            </div>

            {/* Conditional rendering */}
            {type === "editor" && (
              activeTab === "editor" ? (
                editorType === "ckeditor" ? (
                  <CKEditorComponent
                    value={value}
                    onChange={onChange}
                    className={className}
                  />
                ) : (
                  <ReactQuill
                    theme="snow"
                    className={`textarea_quill shadow-box ${className}`}
                    value={value}
                    onChange={(newValue) => onChange(newValue)}
                    modules={modules || defaultModules}
                    formats={formats || defaultFormats}
                  />
                )
              ) : (
                <textarea
                  className="w-full h-60 p-2 border rounded shadow-inner font-mono text-sm"
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                />
              )
            )}

          </>
        ) : type === "checkbox" ? (
          <>
            {options.map((itm: any) => {
              return (
                <label className="flex">
                  <input
                    type="checkbox"
                    checked={value?.includes(itm.id) ? true : false}
                    onChange={(e) => addItem(itm.id)}
                    style={{ accentColor: "#540C0F" }}
                    className="mr-2"
                  />
                  {itm.name}
                </label>
              );
            })}
          </>
        ) : type == "date" ? (
          <>
            <input
              type="date"
              name={name}
              className="relative shadow-box bg-white w-full rounded-lg h-10 overflow-hidden px-2 text-sm  border border-gray-200"
              required={required}
              placeholder={placeholder}
              value={datepipeModel.datetostring(value) || ""}
              min={min}
              max={max}
              disabled={disabled}
              onChange={(e) => {
                onChange(e.target.value);
              }}
            />
          </>
        ) : type == "toggle" ? (
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id={id}
              name={name}
              checked={value ? true : false}
              onChange={(e) => onChange(e.target.checked)}
              style={{ accentColor: "#540C0F" }}
              className="w-4 h-4 cursor-pointer"
              disabled={disabled}
              required={required}
            />
          </div>
        ) : type == "menuDrops" ? (
          <Menu as="div" className="relative  ml-auto">
            {({ open }) => (
              <>
                <div>
                  <Menu.Button
                    disabled={disabled}
                    className={`flex items-center w-full  justify-center   py-[9px] px-[12px]  text-[14px] font-normal text-[#525866] focus:!outline-none  font-medium -tracking-[0.084px]  ${buttonClass}`}
                  >
                    {selectedLabel || "Select"}
                    {open ? (
                      <ChevronUpIcon
                        className="-mr-1 h-5 w-5 text-gray-400 ml-2"
                        aria-hidden="true"
                      />
                    ) : (
                      <ChevronDownIcon
                        className="-mr-1 h-5 w-5 text-gray-400 ml-2"
                        aria-hidden="true"
                      />
                    )}
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items
                    className={`absolute z-40 right-0  focus:ring-0 focus:border-transparent shadow-lg bg-white rounded-lg mt-2 text-sm overflow-auto max-h-60 w-[160px] ${dropdownClass} 
            [&::-webkit-scrollbar]:w-2 
            [&::-webkit-scrollbar-track]:bg-gray-100 
            [&::-webkit-scrollbar-thumb]:bg-gray-300 
            dark:[&::-webkit-scrollbar-track]:bg-neutral-700 
            dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 
            [&::-webkit-scrollbar-thumb]:rounded-lg
          `}
                  >
                    <div className="">
                      {options.map((opt: any, idx: any) => (
                        <Menu.Item key={idx}>
                          {({ active }) => (
                            <button
                              className={`block w-full hover:bg-gray-100 text-left px-4 py-2 text-sm text-gray-700 ${selectedValue === opt.id
                                ? "bg-gray-100 font-semibold"
                                : ""
                                }`}
                              onClick={() => onChange(opt.id)}
                            >
                              {opt.name}
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </>
            )}
          </Menu>
        ) : (
          <input
            type={type}
            id={id}
            name={name}
            onBlur={onBlur}
            className={`relative shadow-box bg-white w-full rounded-lg h-10 overflow-hidden px-2 text-sm ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={maxlength}
            minLength={minlength}
            min={min}
            disabled={disabled}
            onChange={(e: any) => {
              onChange(e.target.value);
            }}
            onKeyDown={onkeyDown}
          />
        )}

        {error ? (
          <>
            <div className="text-danger small mt-1">{error}</div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
});

// Opt-in native markup for screens that must retain their existing styling and
// browser validation. nativeProps use DOM event callbacks; the default control
// continues to use the project's value-based onChange API.
const SharedFormControl = memo(function SharedFormControl(props: any) {
  if (props.variant === "native") {
    const { nativeTag = "input", nativeProps = {}, children } = props;
    return createElement(nativeTag === "textarea" ? "textarea" : "input", nativeProps, children);
  }

  return <FormControl {...props} />;
});

export default SharedFormControl;
